import FulfilmentLocationFormatter from '../components/FulfilmentLocationFormatter';
import React from 'react';

export const fulfilmentLocationFormatter = cell => (
  <FulfilmentLocationFormatter fulfilmentLocationId={cell} />
);

export default fulfilmentLocationFormatter;
